module.exports = { 
      attributes: {"title":"Professionelle Shogi Partien","author":"Richi","categories":["shogi"],"tags":["shogi"],"language":"de","section":"shogi","slug":"Pro Game on Youtube"},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = function render() { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0) };
            this.$options.staticRenderFns = [function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"markdown-body"},[_c('p',[_vm._v("Eine Liste mit einige Professionelle Shogi Partien auf Youtube.\nDie Inhalte sind alle auf japanisch, aber den Partienverlauf kann man sich anschauen.\nIn der Regel gibt es am Ende neben die Auflösung der Partien, meist noch ein kleines Tsumerätsel.")]),_vm._v(" "),_c('p',[_vm._v("https://www.youtube.com/channel/UCwNxufgy9QYZd0agIBLblDA")])]) }];
          }
        }
      },
     }